import { ref, onMounted, onUnmounted } from 'vue'

// 60s matches the coarsest unit a relative-time string needs to notice changing
// ("5 minutes ago" rolling to "6 minutes ago") — no point ticking faster than that.
const TICK_MS = 60_000

const now = ref(new Date())
let activeConsumers = 0
let intervalId = null

const start = () => {
  activeConsumers++
  if (intervalId === null) {
    intervalId = setInterval(() => {
      now.value = new Date()
    }, TICK_MS)
  }
}
const stop = () => {
  activeConsumers = Math.max(0, activeConsumers - 1)
  if (activeConsumers === 0 && intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
}

/**
 * Shared, ref-counted "now" ticking every 60s — every caller reads the same ref
 * and shares one interval no matter how many components use this, torn down
 * once the last one unmounts. Pass the result into formatRelativeDate so
 * relative-time strings (e.g. "5d ago") stay current without polling per-cell.
 */
export const useRelativeNow = () => {
  onMounted(start)
  onUnmounted(stop)
  return now
}
